import cities from "./cities.json"

const getCities = zip => {
  return cities.cities.filter(c => zip.length > 2 && c.zip.startsWith(zip))
               .map(c => ({zip: c.zip, name: c.name}))
}


export const cityService = {
  getCities
}
